<template>
  <div class="errors">
    <Nav :error="true" />
    <div class="error-page">
      <img
        class="cry-lion"
        src="//product.m.suning.com/pds-web/project/pds/wapV3/images/cry-lion.png"
      />
      <p class="description">抱歉，该商品不存在或已下架</p>
      <a class="btn-home" href="//m.suning.com">去首页逛逛</a>
    </div>
  </div>
</template>

<script>
import Nav from '@/components/head/nav.vue'

export default {
  components: {
    Nav
  },
  head() {
    const host = process.env.host
    const version = new Date().getTime()
    return {
      title: '抱歉，该商品不存在或已下架',
      meta: [
        {
          name: 'viewport',
          content:
            'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no'
        }
      ],
      script: [
        {
          src: `${host.res}/public/v5/??js/zepto/1.1.4/app.js?v=${version}`
        },
        {
          src: `${host.res}/project/pdsWeb/wapV3/script/common/alertBox-min.js?v=${version}`
        }
      ]
    }
  },
}
</script>

<style scoped lang="scss">
.error-page {
  background: #f2f2f2;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: sans-serif;
  font-weight: 100 !important;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .description {
    color: #999;
  }

  .cry-lion {
    display: block;
    width: 6rem;
    margin-top: -60px;
  }
  .btn-home {
    display: block;
    width: 4rem;
    height: 1.2rem;
    line-height: 1.2rem;
    margin: 0.42rem auto 0;
    color: #222;
    background-color: #fff;
    border: 1px solid #666;
    border-radius: 0.04rem;
  }
}
.errors {
  /deep/ .header {
    top: 0;
    background: #fff;
  }
  /deep/ .sn-nav-back {
    background: url(~assets/images/head/nav-back2.png) 50% no-repeat;
    background-size: contain;
  }
  /deep/ .sn-nav-action {
    .car-icon {
      background: url(~assets/images/head/nav-cart2.png) 50% no-repeat;
      background-size: contain;
    }
  }
  /deep/ .sn-nav-action {
    .more {
      background: url(~assets/images/head/nav-more2.png) 50% no-repeat;
      background-size: contain;
    }
  }
}
</style>
